module.exports = {
  "$id": "certificate",
  "type": "object",
  "title": "设置用户证件信息",
  "properties": {
    "certType": {
      "title": "证件类型",
      "type": "string"
    },
    "certNo": {
      "title": "证件号",
      "type": "string",
      "customValidate": "certNo"
    }
  },
  "required": [
    "certType",
    "certNo"
  ],
  "errorMessage": {
    "certType": {
      "required": "请选择证件类型"
    },
    "certNo": {
      "required": "请输入证件号"
    }
  }
}
